import React, { useCallback, useEffect, useRef } from "react";
import ActivitySection from "./activity-section";
import styles from "./index.module.scss";
import { useInvActivity } from "../../hooks/react-query/inv-exchange/useInvActivity";
import { useNavigate, useSearchParams } from "react-router-dom";
import MapSection from "../flipper-vault/map-section";
import { NavigateBackToExchange } from "../../utils/inv-exch-amplitude";

export default function InvestorActivity({
  setOpenActivity,
  entityName,
  acctId,
  pubPropertyId
}: {
  setOpenActivity?: any;
  entityName: string;
  acctId: string;
  pubPropertyId?: string;
}) {
  const observerTarget = useRef<HTMLDivElement>(null);
  const [searchParams] = useSearchParams();
  const propertyId = searchParams.get("pid") || pubPropertyId || "";
  const navigate = useNavigate();
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading
  }: any = useInvActivity({ acctId, propertyId });

  const handleObserver = useCallback(
    (entries: IntersectionObserverEntry[]) => {
      const [target] = entries;
      if (target.isIntersecting && hasNextPage && !isFetchingNextPage) {
        fetchNextPage();
      }
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage]
  );

  useEffect(() => {
    const element = observerTarget.current;
    if (!element) return;

    const observer = new IntersectionObserver(handleObserver, {
      threshold: 0.1
    });

    observer.observe(element);

    return () => {
      if (element) observer.unobserve(element);
    };
  }, [handleObserver]);

  return (
    <div className={styles.InvestorActivity}>
      <div className={styles.header}>
        <img
          src="/images/back.svg"
          alt=""
          onClick={() => {
            NavigateBackToExchange({
              property_id: searchParams.get("pid") || "",
              property_sfid: searchParams.get("sfid") || ""
            });
            if (setOpenActivity) {
              setOpenActivity?.(false);
              sessionStorage.removeItem(`activity-${acctId}`);
            } else {
              navigate(-1);
            }
          }}
        />
        <div className={styles.entityName}>
          <div className={styles.preTitle}>Showing nearby homes for: </div>
          {entityName}
        </div>
        <div></div>
      </div>
      <div className={styles.content}>
        <MapSection type={"activity"} visibleCardId={acctId} acctId={acctId} />

        <ActivitySection
          isFetchingNextPage={isFetchingNextPage}
          data={data}
          isLoading={isLoading}
          observerTarget={observerTarget}
        />
      </div>
    </div>
  );
}
